import React, { Component } from "react";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  login_action,
  forgetPassword_action
} from "../../actions/user_login_auth_actions/user_login_auth_action";
import { withRouter } from "../../utils/withRouter";
import Loader from "../../utils/Loader";
import {
  emailValidator,
  loginPasswordValidator,
  loginEmailValidator,
  otpValidator
} from "../../utils/Validator";
import $ from "jquery";
import { responseError, toastError, toastSuccess } from "../../utils/constants";
import { Modal } from "react-bootstrap";
import { getCurrentAwardDetails_action } from '../../actions/static_action/currentAwardDetails_action'
import moment from "moment";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userEmail: "",
      password: "",
      is_showpass: false,
      email: "",
      is_forgotPassword: false,
      isLoading: false,
      is_verifyEmail: false,
      is_verifyOTP: false,
      verifyEmail: "",
      userName: "",
      getOtp: "",
      adminOtp: "",
      forgetNewPass: "",
      forgetConfirmPass: "",
      finalForgetButton: false,
      companyInfo: false,
      //forget
      forgetPassEmail: "",
      OTP: "",
      newPassword: "",
      confirmPassword: "",
      CenterID: "",

      OrderID: "",
      isCommingSoon: false,
      timeLeft: {},
      intervalId: null
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.navigateSignUp = this.navigateSignUp.bind(this);
  }

  componentDidMount() {
    this.setState({
      companyInfo:
        this.props.location.state != null &&
          this.props.location.state.companyInfo != null
          ? this.props.location.state.companyInfo
          : false,

      CenterID:
        this.props.location.state != null &&
          this.props.location.state.CenterID != null
          ? this.props.location.state.CenterID
          : "",
    });

    var url;
    if (
      this.props.location.pathname != null &&
      this.props.location.pathname.includes("/login/")
    ) {
      url =
        this.props.location.pathname != null &&
        this.props.location.pathname.split("/login/");
      this.setState({
        OrderID: url != "" ? (url[1] != "" ? url[1].toString() : "") : "",
      });
    }
  }

  getCountDownDate(e) {
    this.setState({ isLoading: true })
    this.props.getCurrentAwardDetails_action(null)
      .then((data) => {
        if (data.error != 1) {
          if (data.applicationDate != '') {

            const LaunchDate = data.applicationDate[0]["launch_date"]
            const targetDate = moment.utc(LaunchDate);  // Target in UTC

            // Current date in UTC
            const currentDate = moment();  // Current date in UTC
            const split = currentDate.format().split('+')
            const updateCurrentDate = split[0] + 'Z'
            const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');
            if (totalSeconds >= 0) {
              const timer = setInterval(() => {
                this.setState({ timeLeft: this.calculateTimeLeft(LaunchDate) }, () => {
                  this.setState({ isOpen2: true, isLoading: false, isCommingSoon: false });
                });
              }, 1000);
              this.setState({ intervalId: timer });
            } else {
              this.setState({ isCommingSoon: true, isLoading: false }, () => this.handleSubmit(e));

            }
          } else {
            this.handleSubmit(e)
            this.setState({ isCommingSoon: true })
          }

        }
        else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  calculateTimeLeft = (LaunchDate) => {

    const targetDate = moment.utc(LaunchDate);  // Target in UTC
    // console.log("Target Date in UTC: ", targetDate.format()); 

    // Current date in UTC
    const currentDate = moment();  // Current date in UTC
    // console.log("Current Date in UTC: ", currentDate.format().split('+'));
    const split = currentDate.format().split('+')
    const updateCurrentDate = split[0] + 'Z'
    // console.log("Current Date in UTC: ", updateCurrentDate);

    // Calculate the difference between the current time and target time in total seconds
    const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');

    console.log("totalSeconds--------->", totalSeconds)
    // Calculate the total minutes, hours, and days
    const days = Math.floor(totalSeconds / (60 * 60 * 24)); // Convert seconds to days
    const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60)); // Convert remainder to hours
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60); // Convert remainder to minutes
    const seconds = totalSeconds % 60; // Remainder is the seconds

    // If the countdown reaches 0, close the modal and trigger 'handleRegisterNow'
    if (days == 0 && hours == 0 && minutes == 0 && seconds == 0) {
      this.setState({ isOpen2: false }, () => {
        const { intervalId } = this.state;
        if (intervalId) {
          clearInterval(intervalId); // Stop the timer
          this.setState({ intervalId: null }); // Reset the interval ID
        }
        window.location.reload();
      })
    }

    return {
      days: days < 10 ? `0${days}` : days,
      hours: hours < 10 ? `0${hours}` : hours,
      minutes: minutes < 10 ? `0${minutes}` : minutes,
      seconds: seconds < 10 ? `0${seconds}` : seconds,
    };
  };


  handleSubmit(event) {
    event.preventDefault();
    const { userEmail, password, companyInfo, OrderID } = this.state;
    const Status =
      this.props.location.state != null ? this.props.location.state.status : "";
    const myOrderStatus =
      this.props.location.state != null ? this.props.location.state.status : "";
    var errMsg = loginEmailValidator(userEmail);
    var errMsg2 = loginPasswordValidator(password);
    if (errMsg != "" || errMsg2 != "") {
      toastError(errMsg != "" ? errMsg : errMsg2 != "" ? errMsg2 : "");
    } else {
      if (userEmail != " " && password != " ") {
        this.setState({ isLoading: true });
        this.props
          .login_action(userEmail.toString().trim(), password.toString().trim())
          .then((data) => {
            if (data.error != 1) {
              if (data.data["role_id"] == 1 || data.data["role_id"] == 3) {
                setTimeout(() => {
                  // if (data.data["role_id"] == 1) {
                  //   this.props.navigate("/adminDashboard");
                  // } else if (data.data["role_id"] == 2) {
                  //   this.props.navigate('/juryDashboard')
                  // } else if (data.data["role_id"] == 3) {
                  //   this.props.navigate('/adminDashboard')
                  // } else if (data.data["role_id"] == 4) {
                  //   if (sessionStorage.getItem('award_event_profile_id') != null) {
                  //     this.props.navigate('/applicationForm')
                  //   } else {
                  //     this.props.navigate('/applicantDashboard')
                  //   }
                  // } else {
                  //   this.props.navigate("/");
                  // }
                  if (data.data["role_id"] == 1) {
                    this.props.navigate("/adminDashboard");
                  } else if (data.data["role_id"] == 3) {
                    this.props.navigate('/adminDashboard')
                  }else if (data.data["role_id"] == 5) {
                    this.props.navigate('/cms/manage')
                  }
                  this.setState({ isLoading: false });
                }, 2000);
              } else {
                if (this.state.isCommingSoon) {
                  setTimeout(() => {
                    if (data.data["role_id"] == 2) {
                      this.props.navigate('/juryDashboard')
                    } else if (data.data["role_id"] == 4) {
                      if (sessionStorage.getItem('award_event_profile_id') != null) {
                        this.props.navigate('/applicationForm')
                      } else {
                        this.props.navigate('/applicantDashboard')
                      }
                    } else {
                      this.props.navigate("/");
                    }
                    this.setState({ isLoading: false });
                  }, 2000);
                } else {
                  this.getCountDownDate(event)
                }
              }
            } else {
              this.setState({ isLoading: false });
              console.log('data.msg--->', data.msg)
              toastError(data.msg);
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        this.setState({ isLoading: false });

        toastError("Please check user name and password");
      }
    }
  }


  handleKeyDown(e) {
    if (e.code === "Enter") {
      this.handleSubmit(e);
    }
  }

  clearValue() {
    this.setState({
      verifyEmail: "",
      userName: "",
      getOtp: "",
      adminOtp: "",
      forgetNewPass: "",
      forgetConfirmPass: "",
      is_verifyOTP: false,
      is_verifyEmail: false,
    });
  }

  navigateSignUp() {
    const { companyInfo } = this.state;
    const CenterID =
      this.props.location.state != null &&
        this.props.location.state.CenterID != null
        ? this.props.location.state.CenterID
        : "";
    if (companyInfo == false) this.props.navigate("/signUp");
    else {
      this.props.navigate("/signUp", {
        state: { companyInfo: true, CenterID: CenterID },
      });
    }
  }

  onVerifyEmail(e) {
    const { verifyEmail, userEmail, is_forgotPassword } = this.state;
    var errMsg = emailValidator(userEmail);
    if (errMsg != "") {
      toastError(errMsg != "" ? errMsg : "");
    } else {
      if (userEmail != " ") {
        this.setState({ isLoading: true });
        this.isCheckEmailPresent(e);
      }
    }
  }

  isCheckEmailPresent(e) {
    e.preventDefault();
    const { verifyEmail, is_verifyEmail, userEmail } = this.state;

    this.setState({ isLoading: true }); // show loading while API call

    this.props
      .forgetPassword_action(userEmail)
      .then((data) => {
        if (data.error !== 1) {
          this.setState({
            isLoading: false,
            is_verifyEmail: !is_verifyEmail,
            is_forgotPassword: false,
          });
          setTimeout(() => {
            toastSuccess("Reset password link sent to your email");
          }, 2000);

        } else {
          this.setState({ isLoading: false, email: "" });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        this.setState({ isLoading: false });
        console.log(e);
      });
  }

  toggleModal() {
    this.setState(prevState => ({
      is_forgotPassword: !prevState.is_forgotPassword
    }));
  }

  navigateWebsite() {
    this.props.navigate('/')
  }

  render() {
    const {
      userEmail,
      password,
      isLoading,
      is_verifyEmail,
      is_verifyOTP,
      is_showpass,
      is_forgotPassword,
      verifyEmail,
      forgetNewPass,
      forgetConfirmPass,
      timeLeft
    } = this.state;
    return (
      <>
        {isLoading ? <Loader /> : <>
          <>
            {/* {is_forgotPassword && ( */}
            <div className="login-container">
              {/* <img src="img/login_bg_img.png" alt="bg_img" className="bg_img"/> */}
              <div className="login-box">
                <div className="form-section">
                <marquee
                  style={{ fontSize: "16px", color: "#000", fontWeight: "500" }}
                  behavior="scroll"
                  direction="left"
                  scrollamount="5"
                  onMouseOver={(e) => e.target.stop()}
                  onMouseOut={(e) => e.target.start()}
                >
                <b>Disclaimer and Ownership: </b> All content, including text, graphics, images, and other materials on this website and associated online application systems/accounts, is the exclusive property of India ITME Society or is used under appropriate license. Unauthorized copying, reproduction, distribution, publication, display, modification, creation of derivative works, transmission, or any other form of exploitation of this content is strictly prohibited without prior written consent from the copyright owner. Any violation of these terms will result in immediate legal action and enforcement of intellectual property rights.
                </marquee>
                  <img src="../static/images/logo.png" alt="Logo" className="logo" />
                  <h2>{is_forgotPassword ? "Forgot Password" : "Welcome"}</h2>
                  <p>{is_forgotPassword ? "Enter your email address and we’ll send you instructions to reset your password." : "Continue your journey with ITME"}</p>
                  <input type="email" placeholder="Enter Email" className="input-field" value={userEmail}
                    onChange={(e) => this.setState({ userEmail: e.target.value })} onKeyDown={(e) => this.handleKeyDown(e)}
                    maxLength={50} />
                  {is_forgotPassword ? (<>
                    <button className="login-button" onClick={(e) => this.onVerifyEmail(e)}>Continue</button>
                  </>) : (<>
                    <div className="password-container">
                      <input type={is_showpass ? "text" : "password"} value={password}
                        onChange={(e) => this.setState({ password: e.target.value })}
                        onKeyDown={(e) => this.handleKeyDown(e)} maxLength={25}
                        placeholder="Password" className="input-field" />
                      <i className={`fa ${is_showpass ? "fa-eye-slash" : "fa-eye"} show-password`}
                        onClick={() =>
                          this.setState((prevState) => ({ is_showpass: !prevState.is_showpass }))
                        }></i>
                    </div>
                    <button className="login-button"
                      onClick={(e) => { this.handleSubmit(e) }}>LOGIN</button>
                  </>)}
                  <a className="forgot-password" onClick={this.toggleModal}>{is_forgotPassword ? "Back To Login" : "Forgot Password ?"}</a>
                  <button className="login-button" onClick={() => this.props.navigate('/signUp')}>{is_forgotPassword ? "" : "Sign Up"}</button>

                  {/* <ul className="ul_line">
                    <li className="sub-menu-item" ><a >or Continue with</a></li>
                  </ul>

                  <div className="social-buttons">
                    <button className="google-login">
                      <img src="img/google_img.png" />{""}
                      Google
                    </button>
                    <button className="facebook-login">
                      <img src="img/linkedin_img.png" />{""}
                      LinkedIn
                    </button>
                  </div> */}

                  <button class="btn btn-primary w-100 mt-4 py-2" onClick={() => this.navigateWebsite()}> Go to Website &nbsp; <i class="fa fa-long-arrow-right"></i></button>
                </div>

                {/* <div className="banner-section">
                <div className="banner_inner_section">
                  <h3>Inspiring Excellence, Celebrating Global Achievements</h3>
                  <img src="img/login_img_boy.png" alt="Celebrating Achievements" className="banner-image" />
                </div>
              </div> */}
              </div>
            </div>
          </>
          <Modal show={this.state.isOpen2} size="lg" >
            <Modal.Body className="pb-2 pt-2"
              style={{
                backgroundImage: 'url("../static/images/login-page-bg.jpg")',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }}
            >
              <span
                className="pop-close"
                onClick={() => this.setState({ isOpen2: false }, () => {
                  const { intervalId } = this.state;
                  if (intervalId) {
                    clearInterval(intervalId); // Stop the timer
                    this.setState({ intervalId: null }); // Reset the interval ID
                  }
                })}
              >
                X
              </span>
              <div className="container text-center p-4">
                <img
                  src="../static/images/pop-logo.png"
                  alt="logo"
                  className="image timer-pop"
                />
                <h2 className="py-5 text-center com-soon-tag">Coming Soon</h2>
                <h5 className="timer-pop-text com-soon">
                  The sign up will start on 21<sup>st</sup> February 2025 at 12:00
                  noon (IST)
                </h5>
                <h5 className="pt-3  timer-pop-text com-soon">
                  The sign up will be on first come first basis.
                </h5>
                <div className="countdown-out mt-5">
                  <div class="countdown">
                    <div>
                      <span id="days">{timeLeft.days}</span>
                      <small>Days</small>
                    </div>
                    <div>
                      <span id="hours">{timeLeft.hours}</span>
                      <small>Hours</small>
                    </div>
                    <div>
                      <span id="minutes">{timeLeft.minutes}</span>
                      <small>Minutes</small>
                    </div>
                    <div>
                      <span id="seconds">{timeLeft.seconds}</span>
                      <small>Seconds</small>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
          <ToastContainer style={{ position: 'absolute', top: 10, right: 10, zIndex: 99999 }} />
        </>}
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    login_action,
    forgetPassword_action,
    getCurrentAwardDetails_action
  })(Login)
);
